/**
 * @generated SignedSource<<d6eefc5a03716abdbaca8e40915faea8>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type GraphQLDateFormat = "GLOBAL" | "MILLIS" | "USER" | "USER_FRIENDLY" | "%future added value";
export type RendererContentStateQuery$variables = {
  contentId: string;
  format?: GraphQLDateFormat | null | undefined;
  isDraft: boolean;
};
export type RendererContentStateQuery$data = {
  readonly singleContent: {
    readonly contentState: {
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined;
    readonly contentStateLastUpdated: {
      readonly value: string;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type RendererContentStateQuery = {
  response: RendererContentStateQuery$data;
  variables: RendererContentStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "format"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
          }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "restrictionLevel"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "format",
            "variableName": "format"
          }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RendererContentStateQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RendererContentStateQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
    "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
    "metadata": {},
    "name": "RendererContentStateQuery",
    "operationKind": "query",
    "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
  }
};
})();

(node as any).hash = "a7f67982771d8fe760ba232b1260bced";

export default node;
